<template>
  <v-dialog
    v-model="deleteConfirmationDialog"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-text>آیا مطمئن هستید میخواهید حذف شود؟</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="() => noDeleteConfirmationDialog()"
        >
          لغو
        </v-btn>
        <v-btn
          color="error"
          text
          @click="() => yesDeleteConfirmationDialog()"
        >
          حذف شود
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@axios";
import baseConfig from '@/../baseConfig'

export default {
  name: "delete-confirmation",
  props: {
    // eslint-disable-next-line vue/require-default-prop
    deleteConfirmationDialogStatus: Boolean,
    deleteRecordData : Object,
    widgets : Array
  },
  data () {
    return {
      deleteRecord: this.deleteRecordData,
      deleteConfirmationDialog: this.deleteConfirmationDialogStatus // Initial value
    }
  },
  watch: {
    deleteRecordData (newValue) {
      this.deleteRecord = newValue // Update when the prop changes
    },
    deleteConfirmationDialogStatus (newValue) {
      this.deleteConfirmationDialog = newValue // Update when the prop changes
    }
  },
  methods: {
    noDeleteConfirmationDialog() {
      this.deleteRecord = null
      this.deleteConfirmationDialog = false
      this.$emit("initial-delete-confirmation-with-nothing") ;
    },
    yesDeleteConfirmationDialog() {
      this.DeleteRecord(this.deleteRecord.record, this.deleteRecord.tableName, this.deleteRecord.columns)
      this.deleteConfirmationDialog = false
    },
    async DeleteRecord(record, tableName, columns) {
      let otherParams = ''
      // eslint-disable-next-line no-return-assign,no-nested-ternary
      columns.map(c => (c.type === 'delete' ? c.otherParameters.map(op => (op.type === 'param' ? otherParams += (`/${this.$route.params.id}`) : op.type === 'field' ? otherParams += (`/${record[op.from]}`) : null)) : null))
      // eslint-disable-next-line no-return-assign,no-nested-ternary
      columns.map(c => (c.type === 'delete' ? c.action !== '' ? this.deleteUrl = c.action : null : null))
      // eslint-disable-next-line no-return-assign
      if (this.deleteUrl === '' || this.deleteUrl === null) this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? this.deleteUrl = w.data.action : null))
      // eslint-disable-next-line no-return-assign
      this.widgets.map(w => (w.type === 'form' && w.data.id === tableName ? this.deleteUrl = w.data.action : null))
      // eslint-disable-next-line no-unused-vars
      try {
        await axios.delete(`${baseConfig.baseUrl + this.deleteUrl}/${record.id}${otherParams}`).then(r => {
          this.$emit('response_handler', r,true)
          this.$emit("initial-delete-confirmation-with-nothing") ;
        })
      }catch (e) {
        let r= {
          data :{
            message:"خطا در پردازش درخواست ، لطفا مجدد تلاش نماييد .",
            status:"error"
          }
        }
        this.$emit('response_handler', r,true)
        this.$emit("initial-delete-confirmation-with-nothing") ;
      }


    }
  }
}
</script>

<style scoped>

</style>
